import React from 'react';
import { classnames } from '../../utils/classnames';

export default function Preloader({ classname }) {
  return <div className={classnames('preloader', classname)}></div>;
}
